module.exports = __webpack_public_path__ + "img/DaVinci-icon.3310a4f0.png";